import { Component, ContentChildren, QueryList } from '@angular/core';
import { DcSelectComponent } from 'src/app/ui-kit/dc-select/dc-select.component';

@Component({
  selector: 'app-reference-entities',
  templateUrl: './reference-entities.component.html',
  styleUrls: ['./reference-entities.component.scss']
})
export class ReferenceEntitiesComponent {

  @ContentChildren(DcSelectComponent, { descendants: true })
  referencesSelections: QueryList<DcSelectComponent>

}
